import { db } from '@/shared/services/firebase'
import i18n from '@hw-core/libs/i18n'

const header = {
  header: i18n.t('nav.headers.shifts_and_gigs'), // "SHIFTS & GIGS"
  resource: 'Jobs',
  action: 'manage',
}
const menuItems = [
  {
    title: i18n.t('gig_page.titles.menu_item'), // "Gigs Management"
    route: 'apps-gigs-management-list',
    icon: 'RadioIcon',
    resource: 'Jobs',
    action: 'manage',
    /* watchBadgeCount: ({ role, callback }) => {
      if (role !== 'admin') {
        return
      }
      db.collection('orders')
        .where('status', '==', 'open')
        .orderBy('created', 'asc')
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          changes.forEach(change => {
            callback(change)
          })
        })
    }, */
  },
  {
    title: i18n.t('shifts_calendar.titles.menu_item'),
    route: 'apps-shifts-calendar',
    icon: 'CalendarIcon',
    resource: 'Jobs',
    action: 'read',
  },
  {
    title: i18n.t('areas_management.titles.menu_item'),
    route: 'apps-areas-management-list',
    icon: 'MapPinIcon',
    resource: 'Jobs',
    action: 'read',
  },
  {
    title: i18n.t('action_center.titles.menu_item'),
    route: 'apps-action-center',
    icon: 'ActivityIcon',
    resource: 'Jobs',
    action: 'read',
    watchBadgeCount: ({ accountId, onlyAreas, callback }) => {
      let query = db.collection('shifts')
        .where('start', '>=', new Date())
        .where('status', 'in', ['booked'])
        .where('reserved', '==', false)
        .where('verificationRequest', '==', '')
      if(accountId) {
        query = query.where('accountId', '==', accountId)
      }
        query
        .orderBy('start', 'asc')
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          changes.forEach(change => {
            const data = { ...change.doc.data(), id: change.doc.id }
            if (onlyAreas && onlyAreas.indexOf(data.areaId) === -1) {
              return
            }
            callback(change)
          })
        })
      /* let queryQuick = db.collection('shifts')
        .where('end', '<=', new Date())
        .where('status', '==', 'confirmed')
        .where('boostedOptions.boostType', '==', 'quick')
        .where('finalConfirmation.confirmed', '==', false)
        .where('confirmationRequest', '==', '')

      if(accountId) {
        queryQuick = queryQuick.where('accountId', '==', accountId)
      }
        queryQuick
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          changes.forEach(change => {
            const data = { ...change.doc.data(), id: change.doc.id }
            if (onlyAreas && onlyAreas.indexOf(data.areaId) === -1) {
              return
            }
            callback(change)
          })
        }) */
    },
  },
  {
    title: i18n.t('clientRequests.titles.menu_item'),
    route: 'apps-requests',
    icon: 'ShareIcon',
    resource: 'Requests',
    action: 'read',
  },
  {
    title: i18n.t('reports.titles.menu_item'),
    route: 'apps-reports', // TODO why dont we use this instead of :to directive?
    icon: 'DatabaseIcon',
    resource: 'Reports',
    action: 'read',
  },
  {
    title: i18n.t('reviews.titles.menu_item'),
    route: 'apps-reviews',
    icon: 'StarIcon',
    resource: 'Reviews',
    action: 'read',
  },
]

export default { header, menuItems }
